import * as React from 'react'
import ReactMarkdown from 'react-markdown'
import remarkBreaks from 'remark-breaks'
import rehypeFormat from 'rehype-format'

import * as styles from './Markdown.module.scss'

type Props = {
  className?: any
  noParagraphs?: boolean
  children: any
  readMore?: boolean
}

type MarkdownProps = {
  className: any
  disallowedTypes?: any
  noParagraphs?: boolean
  plugins: any
  children: any
  transformLinkUri: any
  linkTarget: any
  unwrapDisallowed?: boolean
}

const linkTarget = (url = '') => {
  let returnTarget
  const localUrl = url.split('?').shift()
  const isMail = url && url.split(':')[0] === 'mailto'
  const isPhone = url && url.split(':')[0] === 'tel'

  if ((localUrl && localUrl.substr(-4, 4) === '.pdf') || isMail || isPhone) {
    returnTarget = '_blank'
  }

  return returnTarget
}

const LinkRenderer = (props: any) => {
  const { children, node } = props
  const { url } = node

  const target = linkTarget(url)

  return (
    <a
      href={url}
      target={target}
      rel={target === '_blank' ? 'noopener noreferrer' : ''}
    >
      {children}
    </a>
  )
}

const Markdown = ({
  className = '',
  noParagraphs = false,
  children,
}: Props): JSX.Element => {
  const plugins = [rehypeFormat]

  const markdownProps: MarkdownProps = {
    className,
    plugins,
    children,
  }

  if (noParagraphs) {
    markdownProps.disallowedTypes = ['paragraph']
    markdownProps.unwrapDisallowed = true
  }

  return (
    <div className={styles.markdown}>
      <ReactMarkdown components={{ link: LinkRenderer }} {...markdownProps} />
    </div>
  )
}

export default Markdown
